module.exports = __webpack_public_path__ + "img/image_signing01@2x.28af372b.png";